import {
  countAvailableTasksByType,
  countTasksByStatus,
  countUserTasksInCampaign,
  subscribeToApprovedTasksInCampaign,
  subscribeToAwaitingReviewInCampaign,
  subscribeToMyApprovedTasks,
  subscribeToMyOpenTasks,
  subscribeToMyReviews,
} from '../../services/tasks';
import type { TaskReadRepository } from '../../domain/tasks/repository';

/** Firebase-backed implementation of the queue's read-only task port. */
export function createTaskRepository(): TaskReadRepository {
  return {
    subscribeAwaitingReviewInCampaign: subscribeToAwaitingReviewInCampaign,
    subscribeMyReviews: subscribeToMyReviews,
    subscribeMyOpenTasks: subscribeToMyOpenTasks,
    subscribeMyApprovedTasks: subscribeToMyApprovedTasks,
    subscribeApprovedTasksInCampaign: subscribeToApprovedTasksInCampaign,
    countAvailableTasksByType,
    countUserTasksInCampaign,
    countTasksByStatus,
  };
}
